const HEX_BASE = 16;
const PAD_LENGTH = 2;

export function stringToColor(str: string) {
  let hash = 0;
  const s = str.toLowerCase();

  for (let i = 0; i < s.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }

  let hex = '';
  for (let i = 0; i < 3; i += 1) {
    // eslint-disable-next-line no-bitwise
    const value = (hash >> (i * 8)) & 0xff;
    hex += value.toString(HEX_BASE).padStart(PAD_LENGTH, '0');
  }

  return hex;
}

export function invertColor(hex: string, bw: boolean) {
  let h = hex[0] === '#' ? hex.slice(1) : hex;

  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }
  if (h.length !== 6) {
    throw new Error('Invalid HEX color.');
  }

  let r: number | string = parseInt(h.slice(0, 2), HEX_BASE);
  let g: number | string = parseInt(h.slice(2, 4), HEX_BASE);
  let b: number | string = parseInt(h.slice(4, 6), HEX_BASE);

  if (bw) {
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '000000' : 'FFFFFF';
  }

  r = (255 - (r as number)).toString(HEX_BASE).padStart(PAD_LENGTH, '0');
  g = (255 - (g as number)).toString(HEX_BASE).padStart(PAD_LENGTH, '0');
  b = (255 - (b as number)).toString(HEX_BASE).padStart(PAD_LENGTH, '0');

  return `${r}${g}${b}`;
}
